import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconCallProps } from './IconCall.types'
import * as Styled from './styles/IconCall.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCall: FC<IconCallProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCallProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconCallProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M21.46 17.21a.43.43 0 0 1 0 .11 3.58 3.58 0 0 1-.16 1 4.39 4.39 0 0 1-2.58 2.87c-3 .9-6.19 0-9-1.43a12.15 12.15 0 0 1-5.38-5.35c-1.42-2.79-2.34-6-1.44-9a4.41 4.41 0 0 1 2.91-2.55l1-.26a.33.33 0 0 1 .39.2L8 5.07l1.18 3.3v.09a.38.38 0 0 1-.18.42 4.56 4.56 0 0 1-1.27.67 8.06 8.06 0 0 1-1.68.33.37.37 0 0 0-.27.16.34.34 0 0 0 0 .31 12.26 12.26 0 0 0 3 5 12.37 12.37 0 0 0 5 3 .34.34 0 0 0 .31 0 .37.37 0 0 0 .16-.26 7.84 7.84 0 0 1 .33-1.67 4.12 4.12 0 0 1 .67-1.26.36.36 0 0 1 .45-.16h.09l3.31 1.18c.79.28 1.46.56 2.25.84.04-.02.09.12.11.19Z'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconCall
